export default __webpack_public_path__ + "static/media/21.6f74f49d.svg";